import React from 'react';
import {Link} from 'react-router-dom';
import profile from '../imgs/profile.jpg';


class ApplicantItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: false
        }
    }
    onClickItem () {
        this.setState({selected: !this.state.selected})
        this.props.selectUser(this.props.user.id)
    }
    renderStar() {
        let n = this.props.user.star;
        let s = []
        for (var i = 0; i < 5; i++) {
            if (i+1 <= n) {
                s.push(<i key={i} className={`fas fa-star `}></i>)
            } else {
                s.push(<i key={i} className={`far fa-star `}></i>)
            }
        }
        return s
    }
  render () {
    let user = this.props.user
    return (
        <div className="app-item" onClick={this.onClickItem.bind(this)}>
            <div className="app-item-select">
                {this.props.selected ? 
                    <i className="fas fa-check-circle fa-lg"></i> : 
                    <i className="far fa-circle fa-lg"></i>}
            </div>
                <div className="app-item-img">
                    <img src={profile} />
                </div>
            <Link className="app-item-link" to={{pathname: `/user/${user.id}`}}>
            <div className="app-item-name">{user.firstName} {user.lastName}</div>
            </Link>
            <div className="app-item-star">
                    {this.renderStar()}
                </div>
            <div className="app-item-stat"><span>{user.ver} ver</span> &middot; <span>{user.rec} rec</span></div>
        </div>
      )
  }
}

export default ApplicantItem;